module.exports = __webpack_public_path__ + "static/BT-mobile-2-7bdd243319b016a1742a1556a3fd5787.jpg";